import { IDashboardContext, useDashboardContext } from "../contexts/dashboard-context";

export const useTextZoneDashboard = () => {
	const { textZone } = useDashboardContext() as IDashboardContext & {
		textZone: eXpress.TextZoneDashboard;
	};

	return textZone;
};
